// Safari-specific fixes and polyfills
export function initSafariFixes() {
    // Check if we're running on Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    if (isSafari) {
        console.log('Safari detected, applying fixes...');
        
        // Fix for CSS custom properties fallback
        if (!CSS.supports('color', 'var(--test)')) {
            console.log('CSS custom properties not supported, applying fallbacks');
            applyCSSFallbacks();
        }
        
        // Fix for localStorage issues
        fixLocalStorage();
        
        // Fix for fetch API if needed
        if (!window.fetch) {
            console.log('Fetch API not supported, loading polyfill');
            loadFetchPolyfill();
        }
    }
}

function applyCSSFallbacks() {
    // Apply fallback styles for browsers that don't support CSS custom properties
    const style = document.createElement('style');
    style.textContent = `
        .loadingBackground {
            background: #00131e !important;
        }
        .loader {
            background: #ffffff !important;
        }
        .loader:after {
            background: #00131e !important;
        }
    `;
    document.head.appendChild(style);
}

function fixLocalStorage() {
    // Safari sometimes has issues with localStorage
    try {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
    } catch (e) {
        console.warn('localStorage not available, using sessionStorage');
        // Fallback to sessionStorage or memory storage
        window.storage = {
            getItem: (key) => sessionStorage.getItem(key),
            setItem: (key, value) => sessionStorage.setItem(key, value),
            removeItem: (key) => sessionStorage.removeItem(key)
        };
    }
}

function loadFetchPolyfill() {
    // Load fetch polyfill for older Safari versions
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/whatwg-fetch@3.6.2/dist/fetch.umd.js';
    script.onload = () => {
        console.log('Fetch polyfill loaded');
    };
    script.onerror = () => {
        console.warn('Failed to load fetch polyfill');
    };
    document.head.appendChild(script);
}

// Initialize fixes when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSafariFixes);
} else {
    initSafariFixes();
}
